<section class=" payment-detail-new-section">
    <span class="payment-titla">saved cards</span>
    <div class="payment mb-3">
        <div class="row">
            <div class="col-8">
                <div class="payment-detail-new">
                    <div class="payment-detail-img-new">
                        <img src="assets/images/visa.svg" alt="icon">
                    </div>
                    <div class="payment-detail-box-new">
                        <span>Khushi idfc</span>
                        <small>......1234</small>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="manage-btn">
                    <span><a>Manage</a></span>
                </div>
            </div>
        </div>
    </div>
    <div class="payment mb-3">
        <div class="row">
            <div class="col-8">
                <div class="payment-detail-new">
                    <div class="payment-detail-img-new">
                        <img src="assets/images/idfc.svg" alt="icon">
                    </div>
                    <div class="payment-detail-box-new">
                        <span>Khushi idfc</span>
                        <small>......1234</small>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="manage-btn">
                    <span><a >Manage</a></span>
                </div>
            </div>
        </div>
    </div>
    <div class="payment mb-3">
        <div class="row">
            <div class="col-8">
                <div class="payment-detail-new">
                    <div class="payment-detail-img-new">
                        <img src="assets/images/visa.svg" alt="icon">
                    </div>
                    <div class="payment-detail-box-new">
                        <span>Khushi idfc</span>
                        <small>......1234</small>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="manage-btn">
                    <span><a >Manage</a></span>
                </div>
            </div>
        </div>
    </div>
    <div class="payment mb-3">
        <div class="row">
            <div class="col-8">
                <div class="payment-detail-new">
                    <div class="payment-detail-img-new">
                        <img src="assets/images/bank-logo.svg" alt="icon">
                    </div>
                    <div class="payment-detail-box-new">
                        <span>Khushi idfc</span>
                        <small>......1234</small>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="manage-btn">
                    <span><a >Manage</a></span>
                </div>
            </div>
        </div>
    </div>
    <div class="add-nw-card-btn">
        <button>Add new Card</button>
    </div>
</section>
<section class=" payment-detail-new-section bank-payment">
    <span class="payment-titla">Wallets</span>
    <div class="payment mb-3">
        <div class="row">
            <div class="col-12">
                <div class="payment-detail-new justify-content-between">
                    <div class="account-detail">
                        <div class="payment-detail-img-new">
                            <img src="assets/images/paytm-logo.svg" alt="icon">
                        </div>
                        <div class="payment-detail-box-new">
                            <span>Paytm</span>
                            <small>8654834568</small>
                        </div>
                    </div>
                    <div class="paytm">
                        <span>₹1000</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="payment mb-3">
        <div class="row">
            <div class="col-8">
                <div class="payment-detail-new">
                    <div class="payment-detail-img-new">
                        <img src="assets/images/google-pay-logo.svg" alt="icon">
                    </div>
                    <div class="payment-detail-box-new">
                        <span>Khushi idfc</span>
                        <small>......1234</small>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="manage-btn">
                    <span><a >link Account</a></span>
                </div>
            </div>
        </div>
    </div>
    <div class="payment mb-3">
        <div class="row">
            <div class="col-8">
                <div class="payment-detail-new">
                    <div class="payment-detail-img-new">
                        <img src="assets/images/mobikwik-logo.svg" alt="icon">
                    </div>
                    <div class="payment-detail-box-new">
                        <span>Khushi idfc</span>
                        <small>......1234</small>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="manage-btn">
                    <span><a >link Account</a></span>
                </div>
            </div>
        </div>
    </div>
    <div class="payment mb-3">
        <div class="row">
            <div class="col-8">
                <div class="payment-detail-new">
                    <div class="payment-detail-img-new">
                        <img src="assets/images/phonepe-logo.svg" alt="icon">
                    </div>
                    <div class="payment-detail-box-new">
                        <span>Khushi idfc</span>
                        <small>......1234</small>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="manage-btn">
                    <span><a >link Account</a></span>
                </div>
            </div>
        </div>
    </div>
</section>